export enum PickingListDeliveryType {
    Employee = 1,
    Partner = 2
}